import { CSSObject } from '@emotion/serialize';
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { CSSObjectWithLabel } from '@atlaskit/react-select';
import { ControlProps } from '@atlaskit/select';
import { gridSize, layers } from '@atlaskit/theme';

import { subtleSelector } from 'src/sections/repository/styles/filters';
import { selectControlStyles } from 'src/styles/select';

export const FilterContainer = styled.div({
  margin: `0 0 ${gridSize() * 2}px 0`,
});

export const prFilterSelectStyle = {
  control: (
    css: CSSObjectWithLabel,
    state: ControlProps<
      {
        label: string;
        value: string;
      },
      false
    >
  ): CSSObject => ({
    ...css,
    ...subtleSelector(css, state),
    ...selectControlStyles,
    minWidth: gridSize() * 12,
    maxWidth: gridSize() * 20,
  }),
  singleValue: (css: CSSObject): CSSObject => ({
    ...css,
    lineHeight: 'inherit',
  }),
  menu: (css: CSSObject): CSSObject => ({
    ...css,
    zIndex: layers.navigation(),
  }),
};
